import styled, { css } from 'styled-components';
export const SubmitButton = styled.button `
  ${({ theme: { submitButton } }) => submitButton}

  ${({ isDisabled }) => isDisabled && css `
    background-color: #CDCDCD;
  `}
`;
export const ContinueButton = styled.button `
  ${({ theme: { continueButton } }) => continueButton}
  
  ${({ isDisabled }) => isDisabled && css `
    background-color: #CDCDCD;
  `}
`;
